export default "__VITE_ASSET__DNAL88T7__"